"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteProductValue = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const create_product_value_assertion_mutation_1 = require("../create-product-value-assertion.mutation");
const useDeleteProductValue = () => {
    const [deleteProductValueMutation] = (0, react_2.useMutation)(create_product_value_assertion_mutation_1.CREATE_PRODUCT_VALUE_ASSERTION);
    const deleteProductValue = (0, react_1.useCallback)((values, attributeId, productIds) => __awaiter(void 0, void 0, void 0, function* () {
        const variableList = [];
        for (const productId of productIds) {
            const attributeValuePairs = values.map((value) => ({
                label: attributeId,
                type: graphql_1.ProductAttributeAssertionType.Negative,
                value,
            }));
            variableList.push([attributeValuePairs, productId]);
        }
        const promises = variableList.map(([labels, productId]) => new Promise((resolve, reject) => {
            void deleteProductValueMutation({
                variables: {
                    product: {
                        id: productId,
                        clientMutationId: '',
                        labels,
                    },
                    labelName: attributeId,
                },
                // Prevent Apollo from auto-merging intermediate mutation response into cache.
                // Cache is managed manually via optimistic update (Phase 1) and server data replacement (Phase 2).
                fetchPolicy: 'no-cache',
                onError: (error) => reject(new Error(error.message)),
                onCompleted: (data) => resolve(data.productAssertion),
            });
        }));
        const results = yield Promise.all(promises);
        const errors = results.filter(({ error }) => error).map(({ error }) => error);
        const errorMessage = errors.join(', ');
        if (errorMessage) {
            throw new Error(errorMessage);
        }
        return results;
    }), [deleteProductValueMutation]);
    return {
        deleteProductValue,
    };
};
exports.useDeleteProductValue = useDeleteProductValue;
exports.default = exports.useDeleteProductValue;
